module.exports = __webpack_public_path__ + "img/shoeCover.f17b85f7.png";